export default "__VITE_ASSET__CX6OMh$L__"